import { createAction, createAsyncAction } from "typesafe-actions";

import * as T from "./types";
import { FireType } from "@/features/firestore";

export const updateSelectedTicker = createAction("UPDATE_TRADE_SELECTED_TICKER")<string>();

export const updateIsBuy = createAction("UPDATE_TRADE_IS_BUY_TICKER")<boolean>();

export const deletePortfolio = createAsyncAction(
  "DELETE_TRADE_PORTFOLIO_REQUEST",
  "DELETE_TRADE_PORTFOLIO_SUCCESS",
  "DELETE_TRADE_PORTFOLIO_FAILURE"
)<{name: string, portfolioId: string}, void, void>();

export const fetchTradeMeta = createAsyncAction(
  "FETCH_TRADE_META_REQUEST",
  "FETCH_TRADE_META_SUCCESS",
  "FETCH_TRADE_META_FAILURE"
)<void, T.TradeMeta, void>();

export const findTickers = createAsyncAction(
  "FIND_TRADE_TICKERS_REQUEST",
  "FIND_TRADE_TICKERS_SUCCESS",
  "FIND_TRADE_TICKERS_FAILURE"
)<{ region: string; text: string }, T.Tickers[], void>();

export const fetchTickerSummary = createAsyncAction(
  "FETCH_TRADE_TICKER_SUMMARY_REQUEST",
  "FETCH_TRADE_TICKER_SUMMARY_SUCCESS",
  "FETCH_TRADE_TICKER_SUMMARY_FAILURE"
)<string, T.TickerSummary, void>();

export const fetchPortfolioMetrics = createAsyncAction(
  "FETCH_PORTFOLIO_METRICS_REQUEST",
  "FETCH_PORTFOLIO_METRICS_SUCCESS",
  "FETCH_PORTFOLIO_METRICS_FAILURE"
)<{portfolioId: string}, T.PortfolioMetrics, void>();

export const performTrade = createAsyncAction(
  "PERFORM_TRADE_REQUEST",
  "PERFORM_TRADE_SUCCESS",
  "PERFORM_TRADE_FAILURE"
)<{ transaction: T.Transaction; positions: FireType.Position[]; cash: number; value: number }, void, void>();
